// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-bar[data-v-13007665]{width:100%;height:8px;border-radius:4px;overflow:hidden}.progress-bar__fill[data-v-13007665]{height:100%;border-radius:4px;transition:width 1s ease}", ""]);
// Exports
module.exports = exports;
